<template lang="pug">
table
  tr
    th
      b-form-checkbox(v-model="allSelected" @change="selectAll")
    th
      span.font-weight-bold {{ allSelected  ? $t('ui.unselect_all') : $t('ui.select_all') }}
  tr(v-for='p in options')
    td
      b-form-checkbox(:value='p.provider_group' @input="handleInput")
    td {{ p.provider_group }}
  //- b-form-select(
  //-   :value="value"
  //-   :size="size"
  //-   :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  //-   @input="handleInput"
  //-   )
  //-   option(value="" disabled selected) {{ $t("message.select_option") }}
  //-   option(v-for="option in options" :value="option.provider_group") {{ option.provider_group }}
</template>

<script>
import config from "@/config";

export default {
  props: {
    value: {
      type: Array,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    category: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    options: [],
    payment_option_list: [],
    allSelected: false,
    feedback: {
      success: true,
      status: ""
    }
  }),
  watch : {
    value(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelected = false;
      else if (newValue.length === this.options.length)
        this.allSelected = true;
      else
        this.allSelected = false;
    }
  },
  mounted: function() {
    this.getBankProviderList();
  },
  methods: {
    selectAll: function() {
      // console.log("selectAll", this.value)
      // this.value = [];

      // let list = this.options;

      // if (!this.allSelected) {
      //   for(var i = 0; i < list.length; i++) {
      //     this.value.push(list[i].value);
      //   }
      // }
    },
    getBankProviderList: function() {
      let url = config.bankProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.options = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      // console.log(e)
      this.$emit("input", e);
    }
  }
};
</script>
